/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  .btn-back {
    margin-top: 20px;
  }

  .page-title {
    margin-bottom: 10px;
  }

  .page-form {
    padding: 24px 32px;
    padding-top: 0;
    display: flex;
    justify-content: space-between;
  }

  .left-side {
    flex-basis: 47%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .right-side {
    flex-basis: 47%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  
  .challenge-top {
    margin: 20px 0;
    text-align: center;
  }

  .day-tag {
    margin-bottom: 5px;
    text-align: center;
    color: #547756;
    border: 1px solid #547756;
    font-size: 12px;
    padding: 2px 5px;
    border-radius: 5px;
    display: inline-block;
  }

  .content-box {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f7f7f6;
    border-radius: 5px;
  }

  .box-title {
    font-size: 14px;
  }

  .box-content {
    font-size: 12px;
    margin: 10px 0;
    white-space: pre-line;
    word-wrap: break-word;
    & > div {
      white-space: pre-line;
      word-wrap: break-word;
    }
  }

  .box-icon {
   width: 20px;
   height: 20px;
   border-radius: 5px;
   font-size: 12px;
   text-align: center;
   line-height: 20px;
   margin-right: 5px;
  }
  .blue-icon {
    background-color: #bae7ff;
  }
  .yellow-icon {
    background-color: #fff188;
  }
  .pink-icon {
    background-color: #efdbff;
  }
`;

